import { useState } from 'react';
import {
    useDeleteApartmentDocumentMutation,
    useGetApartmentDocumentsMutation,
    usePostApartmentDocumentMutation
} from '@services/member/apartment/apartment.endpoints';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CdnFile } from '@services/core/cdn/file/file';

export const useDetailsDocumentsVM = () => {
    const { id } = useParams();
    const [documents, setDocuments] = useState<CdnFile[]>([]);

    const [
        getApartment,
        {
            isLoading: isGetApartmentDocumentsLoading,
            isUninitialized: isGetApartmentDocumentsUninitialized,
            isError: isGetApartmentDocumentsError,
            isSuccess: isGetApartmentDocumentsSuccess,
            error: getApartmentDocumentsError,
            data: getApartmentDocumentsResponse
        }
    ] = useGetApartmentDocumentsMutation();

    const [deleteApartmentDocument] = useDeleteApartmentDocumentMutation();
    const [postApartmentDocument] = usePostApartmentDocumentMutation();

    const handleDeleteDocument = async (documentId: string) => {
        await deleteApartmentDocument({ id: id as string, documentId });
    };

    const handlePostDocument = async (file: CdnFile) => {
        await postApartmentDocument({ id: id as string, file });
    };

    useEffect(() => {
        if (!id) return;
        getApartment({ id });
    }, [id]);

    useEffect(() => {
        if (isGetApartmentDocumentsLoading) return;
        if (isGetApartmentDocumentsError) return;
        if (getApartmentDocumentsError) return;

        if (isGetApartmentDocumentsSuccess && getApartmentDocumentsResponse) {
            setDocuments(getApartmentDocumentsResponse.data);
        }
    }, [
        isGetApartmentDocumentsError,
        isGetApartmentDocumentsSuccess,
        getApartmentDocumentsError,
        getApartmentDocumentsResponse,
        isGetApartmentDocumentsLoading
    ]);

    return {
        isLoading: isGetApartmentDocumentsUninitialized || isGetApartmentDocumentsLoading,
        isError: isGetApartmentDocumentsError,
        documents,
        handleDeleteDocument,
        handlePostDocument
    };
};
